<template>
  <div class="w-100">
    <div class="row no-gutters cursor-pointer" @click="toggleSelect">
      <div class="col-1 align-self-center">
        <svg v-if="is_option_selected" width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16 0H2C0.900024 0 0 0.900024 0 2V16C0 17.1 0.900024 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.900024 17.1 0 16 0ZM16 16H2V2H16V16ZM13.58 4.58002L14.99 6L6.98999 14L2.98999 10.01L4.41003 8.60004L6.98999 11.17L13.58 4.58002Z" class="fill-primary"/>
        </svg>
        <svg v-else width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0H16C17.1 0 18 0.900024 18 2V16C18 17.1 17.1 18 16 18H2C0.900024 18 0 17.1 0 16V2C0 0.900024 0.900024 0 2 0ZM16 16V2H2V16H16Z" fill="#ddd"/>
        </svg>
      </div>
      <div class="col-11 align-self-center">
        <p class="mb-0 body-1-4">Want to customize the deposit?</p>
        <p class="mb-0 body-2-2-1">You can change the total deposit from the lowest, which is {{$formatCurrency(minimum_deposit)}}, or you can pay it in its entirety</p>
      </div>
    </div>
    <div class="row no-gutters" v-if="is_option_selected">
      <div class="col-12 my-3">
        <span class="d-block border-2-bottom-dashed"></span>
      </div>
      <div class="col-9 align-self-end">
        <div class="w-100 pr-3">
          <span class="body-2 mb-1 d-block">Deposit that you will pay</span>
          <div class="w-100 radius-6 border-semi-grey">
            <div class="row slim-grid-row">
              <div class="col-3 align-self-center">
                <div class="w-100 text-center border-right" style="padding:13px 0px;">
                  <span class="mb-0 body-1-4 text-green">{{ getCurrency.symbol_native }}</span>
                </div>
              </div>
              <div class="col-9 align-self-center">
                <input type="number" v-model="price" class="form-control no-focus-border font-bold border-none no-spin px-0 text-18">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3 align-self-end">
        <state-button :click="submitNewDeposit" variant="secondary" size="lg" block>Change</state-button>
      </div>
      <div class="col-9 mt-2" v-if="form_invalid != ''">
        <p class="text-danger text-12 font-semibold">{{ form_invalid }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  
  export default {
    props:{
      minimum_deposit:{
        type: Number,
        default: 0
      },
      total_order:{
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        is_option_selected: false,
        price: 0
      }
    },
    computed:{
      ...mapGetters(['getCurrency']),
      form_invalid(){
        let msg = ''
        let is_data_lacking = this.price < this.minimum_deposit
        let is_data_exceeded = this.price > this.total_order
        
        if(!this.$isNumberOnly(this.price)) msg = 'Make sure you enter the correct amount'
        else if(is_data_lacking) msg = `Minimum deposit can be pay is ${this.$formatCurrency(this.minimum_deposit)}`
        else if(is_data_exceeded) msg = 'The deposit exceeds the total order'
        else msg = ''

        return msg
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods: {
      toggleSelect() {
        this.is_option_selected = !this.is_option_selected
      },
      loadFirstData(){
        this.price = this.minimum_deposit
      },
      submitNewDeposit(){
        return new Promise((succes,fail)=>{
          success()
        })
      }
    },
  }
</script>
<style>
  .no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  .no-spin {
    -moz-appearance:textfield !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/CustomDeposit.vue